import { debounce } from "./helpers";

const verticalScrollerList = [];
export const verticalScroller = (el) => {
    let itemWidth = 100;
    const scroller = el.querySelector(".scroll-items");

    const setSize = (el) => {
        let set = scroller.scrollWidth > scroller.clientWidth;
        el.classList.toggle("has-scrollbar", set);
        itemWidth = scroller.children[0].clientWidth;
    };

    const resized = () => {
        verticalScrollerList.forEach((el) => {
            setSize(el);
        });
    };

    const move = (btn, el) => {
        scroller.scroll({
            top: 0,
            left:
                scroller.scrollLeft +
                (btn.classList.contains("prev") ? -itemWidth : itemWidth),
            behavior: "smooth",
        });
    };

    const scroll = (scroller) => {
        let max = scroller.scrollWidth - scroller.offsetWidth;
        let left = scroller.scrollLeft;
        let diff = 50;

        el.classList.toggle("at-end", left + diff > max);
        el.classList.toggle("at-start", left - diff < 0);
    };

    if (verticalScrollerList.length == 0) {
        window.addEventListener("resize", debounce(resized, 300));
    }

    el.querySelectorAll(".btn").forEach((btn) => {
        btn.addEventListener("click", function () {
            move(btn, el);
        });
    });

    scroller.addEventListener("scroll", function (e) {
        scroll(e.currentTarget);
    });

    setSize(el);
    scroll(scroller);

    verticalScrollerList.push(el);
};
